// 多语言翻译系统
const translations = {
  // 英语 (默认)
  'en': {
    'trackYourOrder': 'Track Your Order',
    'orderNumber': 'Order Number',
    'trackingNumber': 'Tracking Number',
    'email': 'Email',
    'findOrder': 'FIND ORDER',
    'track': 'TRACK',
    'orderDetails': 'Order Details',
    'product': 'Product',
    'quantity': 'Quantity',
    'total': 'Total',
    'status': 'Status',
    'size': 'Size',
    'packaging': 'Packaging: Carton package',
    'sku': 'SKU',
    'shipped': 'Shipped',
    'processing': 'Processing',
    'deliveryAddress': 'Delivery address',
    'payment': 'Payment',
    'productAmount': 'Product Amount',
    'discount': 'Discount',
    'shipping': 'Shipping',
    'totalAmount': 'Total Amount',
    'trackThisPackage': 'TRACK THIS PACKAGE',
    'noOrderFound': 'No order found. Please check your email and order number.',
    'errorOccurred': 'An error occurred. Please try again later.',
    'enterTrackingNumber': 'Please enter your tracking number.',
    'loadingTracking': 'Loading tracking information...',
    'searchingOrder': 'Searching for your order...',
    'enterBothFields': 'Please enter both email and order number.'
  },
    // 波兰语 (pl)
  'pl': {
    'trackYourOrder': 'Śledź Swoje Zamówienie',
    'orderNumber': 'Numer Zamówienia',
    'trackingNumber': 'Numer Przesyłki',
    'email': 'Email',
    'findOrder': 'ZNAJDŹ ZAMÓWIENIE',
    'track': 'ŚLEDŹ',
    'orderDetails': 'Szczegóły Zamówienia',
    'product': 'Produkt',
    'quantity': 'Ilość',
    'total': 'Suma',
    'status': 'Status',
    'size': 'Rozmiar',
    'packaging': 'Opakowanie: Karton',
    'sku': 'Kod Produktu',
    'shipped': 'Wysłane',
    'processing': 'W trakcie realizacji',
    'deliveryAddress': 'Adres dostawy',
    'payment': 'Płatność',
    'productAmount': 'Wartość produktów',
    'discount': 'Rabat',
    'shipping': 'Dostawa',
    'totalAmount': 'Kwota całkowita',
    'trackThisPackage': 'ŚLEDŹ TĘ PACZKĘ',
    'noOrderFound': 'Nie znaleziono zamówienia. Sprawdź swój email i numer zamówienia.',
    'errorOccurred': 'Wystąpił błąd. Spróbuj ponownie później.',
    'enterTrackingNumber': 'Wprowadź numer przesyłki.',
    'loadingTracking': 'Ładowanie informacji o przesyłce...',
    'searchingOrder': 'Szukanie Twojego zamówienia...',
    'enterBothFields': 'Wprowadź zarówno email jak i numer zamówienia.'
  },
  // 中文
   'ja': {

      'trackYourOrder': '注文状況の追跡',
      'orderNumber': '注文番号',
      'trackingNumber': '追跡番号',
      'email': 'メールアドレス',
      'findOrder': '注文を検索',
      'track': '追跡',
      'orderDetails': '注文の詳細',
      'product': '商品',
      'quantity': '数量',
      'total': '合計',
      'status': 'ステータス',
      'size': 'サイズ',
      'packaging': '梱包：カートン',
      'sku': 'SKU',
      'shipped': '発送済み',
      'processing': '処理中',
      'deliveryAddress': '配送先住所',
      'payment': 'お支払い',
      'productAmount': '商品金額',
      'discount': '割引',
      'shipping': '送料',
      'totalAmount': '合計金額',
      'trackThisPackage': 'この荷物を追跡',
      'noOrderFound': '注文が見つかりません。メールアドレスと注文番号をご確認ください。',
      'errorOccurred': 'エラーが発生しました。しばらくしてからもう一度お試しください。',
      'enterTrackingNumber': '追跡番号を入力してください。',
      'loadingTracking': '追跡情報を読み込んでいます...',
      'searchingOrder': 'ご注文を検索しています...',
      'enterBothFields': 'メールアドレスと注文番号の両方を入力してください。'
  },

     'zh': {
          'trackYourOrder': '注文状況の追跡',
      'orderNumber': '注文番号',
      'trackingNumber': '追跡番号',
      'email': 'メールアドレス',
      'findOrder': '注文を検索',
      'track': '追跡',
      'orderDetails': '注文の詳細',
      'product': '商品',
      'quantity': '数量',
      'total': '合計',
      'status': 'ステータス',
      'size': 'サイズ',
      'packaging': '梱包：カートン',
      'sku': 'SKU',
      'shipped': '発送済み',
      'processing': '処理中',
      'deliveryAddress': '配送先住所',
      'payment': 'お支払い',
      'productAmount': '商品金額',
      'discount': '割引',
      'shipping': '送料',
      'totalAmount': '合計金額',
      'trackThisPackage': 'この荷物を追跡',
      'noOrderFound': '注文が見つかりません。メールアドレスと注文番号をご確認ください。',
      'errorOccurred': 'エラーが発生しました。しばらくしてからもう一度お試しください。',
      'enterTrackingNumber': '追跡番号を入力してください。',
      'loadingTracking': '追跡情報を読み込んでいます...',
      'searchingOrder': 'ご注文を検索しています...',
      'enterBothFields': 'メールアドレスと注文番号の両方を入力してください。'
  },
  // 芬兰语 (fi)
  'fi': {
    'trackYourOrder': 'Seuraa Tilaustasi',
    'orderNumber': 'Tilausnumero',
    'trackingNumber': 'Seurantanumero',
    'email': 'Sähköposti',
    'findOrder': 'ETSI TILAUS',
    'track': 'SEURAA',
    'orderDetails': 'Tilauksen Tiedot',
    'product': 'Tuote',
    'quantity': 'Määrä',
    'total': 'Yhteensä',
    'status': 'Tila',
    'size': 'Koko',
    'packaging': 'Pakkaus: Pahvipakkaus',
    'sku': 'Tuotekoodi',
    'shipped': 'Lähetetty',
    'processing': 'Käsittelyssä',
    'deliveryAddress': 'Toimitusosoite',
    'payment': 'Maksu',
    'productAmount': 'Tuotteiden summa',
    'discount': 'Alennus',
    'shipping': 'Toimitus',
    'totalAmount': 'Kokonaissumma',
    'trackThisPackage': 'SEURAA TÄTÄ PAKETTIA',
    'noOrderFound': 'Tilausta ei löytynyt. Tarkista sähköpostiosoitteesi ja tilausnumerosi.',
    'errorOccurred': 'Tapahtui virhe. Yritä myöhemmin uudelleen.',
    'enterTrackingNumber': 'Syötä seurantanumerosi.',
    'loadingTracking': 'Ladataan seurantatietoja...',
    'searchingOrder': 'Etsitään tilaustasi...',
    'enterBothFields': 'Syötä sekä sähköpostiosoite että tilausnumero.'
  },
  // 斯洛伐克语 (sk)
  'sk': {
    'trackYourOrder': 'Sledujte Vašu Objednávku',
    'orderNumber': 'Číslo Objednávky',
    'trackingNumber': 'Sledovacie Číslo',
    'email': 'Email',
    'findOrder': 'NÁJSŤ OBJEDNÁVKU',
    'track': 'SLEDOVAŤ',
    'orderDetails': 'Detaily Objednávky',
    'product': 'Produkt',
    'quantity': 'Množstvo',
    'total': 'Celkom',
    'status': 'Stav',
    'size': 'Veľkosť',
    'packaging': 'Balenie: Kartónová krabica',
    'sku': 'Kód produktu',
    'shipped': 'Odoslané',
    'processing': 'Spracováva sa',
    'deliveryAddress': 'Dodacia adresa',
    'payment': 'Platba',
    'productAmount': 'Suma za produkty',
    'discount': 'Zľava',
    'shipping': 'Poštovné',
    'totalAmount': 'Celková suma',
    'trackThisPackage': 'SLEDOVAŤ TENTO BALÍK',
    'noOrderFound': 'Objednávka nebola nájdená. Skontrolujte váš email a číslo objednávky.',
    'errorOccurred': 'Vyskytla sa chyba. Skúste to prosím neskôr.',
    'enterTrackingNumber': 'Zadajte sledovacie číslo.',
    'loadingTracking': 'Načítavajú sa informácie o sledovaní...',
    'searchingOrder': 'Hľadá sa vaša objednávka...',
    'enterBothFields': 'Zadajte email aj číslo objednávky.'
  },
  // 瑞典语 (sv)
  'sv': {
    'trackYourOrder': 'Spåra Din Beställning',
    'orderNumber': 'Ordernummer',
    'trackingNumber': 'Spårningsnummer',
    'email': 'E-post',
    'findOrder': 'HITTA ORDER',
    'track': 'SPÅRA',
    'orderDetails': 'Orderinformation',
    'product': 'Produkt',
    'quantity': 'Antal',
    'total': 'Totalt',
    'status': 'Status',
    'size': 'Storlek',
    'packaging': 'Förpackning: Kartongförpackning',
    'sku': 'Artikelnummer',
    'shipped': 'Skickad',
    'processing': 'Behandlas',
    'deliveryAddress': 'Leveransadress',
    'payment': 'Betalning',
    'productAmount': 'Produktbelopp',
    'discount': 'Rabatt',
    'shipping': 'Frakt',
    'totalAmount': 'Totalbelopp',
    'trackThisPackage': 'SPÅRA DETTA PAKET',
    'noOrderFound': 'Ingen order hittades. Kontrollera din e-post och ordernummer.',
    'errorOccurred': 'Ett fel inträffade. Försök igen senare.',
    'enterTrackingNumber': 'Vänligen ange ditt spårningsnummer.',
    'loadingTracking': 'Laddar spårningsinformation...',
    'searchingOrder': 'Söker efter din beställning...',
    'enterBothFields': 'Ange både e-post och ordernummer.'
  },
  // 意大利语 (it)
  'it': {
    'trackYourOrder': 'Traccia il Tuo Ordine',
    'orderNumber': 'Numero d\'Ordine',
    'trackingNumber': 'Numero di Tracciamento',
    'email': 'Email',
    'findOrder': 'TROVA ORDINE',
    'track': 'TRACCIA',
    'orderDetails': 'Dettagli dell\'Ordine',
    'product': 'Prodotto',
    'quantity': 'Quantità',
    'total': 'Totale',
    'status': 'Stato',
    'size': 'Taglia',
    'packaging': 'Imballaggio: Scatola di cartone',
    'sku': 'Codice Articolo',
    'shipped': 'Spedito',
    'processing': 'In Lavorazione',
    'deliveryAddress': 'Indirizzo di consegna',
    'payment': 'Pagamento',
    'productAmount': 'Importo prodotti',
    'discount': 'Sconto',
    'shipping': 'Spedizione',
    'totalAmount': 'Importo totale',
    'trackThisPackage': 'TRACCIA QUESTO PACCO',
    'noOrderFound': 'Nessun ordine trovato. Controlla la tua email e il numero d\'ordine.',
    'errorOccurred': 'Si è verificato un errore. Riprova più tardi.',
    'enterTrackingNumber': 'Inserisci il tuo numero di tracciamento.',
    'loadingTracking': 'Caricamento informazioni di tracciamento...',
    'searchingOrder': 'Ricerca del tuo ordine...',
    'enterBothFields': 'Inserisci sia l\'email che il numero d\'ordine.'
  },
  // 捷克语 (cs)
  'cs': {
    'trackYourOrder': 'Sledování Vaší Objednávky',
    'orderNumber': 'Číslo Objednávky',
    'trackingNumber': 'Sledovací Číslo',
    'email': 'Email',
    'findOrder': 'NAJÍT OBJEDNÁVKU',
    'track': 'SLEDOVAT',
    'orderDetails': 'Detaily Objednávky',
    'product': 'Produkt',
    'quantity': 'Množství',
    'total': 'Celkem',
    'status': 'Stav',
    'size': 'Velikost',
    'packaging': 'Balení: Kartonová krabice',
    'sku': 'Kód zboží',
    'shipped': 'Odesláno',
    'processing': 'Zpracovává se',
    'deliveryAddress': 'Dodací adresa',
    'payment': 'Platba',
    'productAmount': 'Částka za zboží',
    'discount': 'Sleva',
    'shipping': 'Doprava',
    'totalAmount': 'Celková částka',
    'trackThisPackage': 'SLEDOVAT TENTO BALÍČEK',
    'noOrderFound': 'Objednávka nenalezena. Zkontrolujte svůj email a číslo objednávky.',
    'errorOccurred': 'Došlo k chybě. Zkuste to prosím později.',
    'enterTrackingNumber': 'Zadejte své sledovací číslo.',
    'loadingTracking': 'Načítání informací o sledování...',
    'searchingOrder': 'Hledání vaší objednávky...',
    'enterBothFields': 'Zadejte email i číslo objednávky.'
  },
  // 葡萄牙语 (pt)
  'pt': {
    'trackYourOrder': 'Rastrear Seu Pedido',
    'orderNumber': 'Número do Pedido',
    'trackingNumber': 'Número de Rastreamento',
    'email': 'Email',
    'findOrder': 'ENCONTRAR PEDIDO',
    'track': 'RASTREAR',
    'orderDetails': 'Detalhes do Pedido',
    'product': 'Produto',
    'quantity': 'Quantidade',
    'total': 'Total',
    'status': 'Status',
    'size': 'Tamanho',
    'packaging': 'Embalagem: Caixa de papelão',
    'sku': 'Código do Produto',
    'shipped': 'Enviado',
    'processing': 'Em Processamento',
    'deliveryAddress': 'Endereço de entrega',
    'payment': 'Pagamento',
    'productAmount': 'Valor dos produtos',
    'discount': 'Desconto',
    'shipping': 'Frete',
    'totalAmount': 'Valor total',
    'trackThisPackage': 'RASTREAR ESTE PACOTE',
    'noOrderFound': 'Nenhum pedido encontrado. Verifique seu email e número do pedido.',
    'errorOccurred': 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
    'enterTrackingNumber': 'Por favor, insira seu número de rastreamento.',
    'loadingTracking': 'Carregando informações de rastreamento...',
    'searchingOrder': 'Procurando seu pedido...',
    'enterBothFields': 'Insira o email e o número do pedido.'
  },
   // 法语
  'fr': {
    'trackYourOrder': 'Suivez Votre Commande',
    'orderNumber': 'Numéro de Commande',
    'trackingNumber': 'Numéro de Suivi',
    'email': 'Email',
    'findOrder': 'TROUVER LA COMMANDE',
    'track': 'SUIVRE',
    'orderDetails': 'Détails de la Commande',
    'product': 'Produit',
    'quantity': 'Quantité',
    'total': 'Total',
    'status': 'Statut',
    'size': 'Taille',
    'packaging': 'Emballage: Carton',
    'sku': 'Référence',
    'shipped': 'Expédié',
    'processing': 'En Traitement',
    'deliveryAddress': 'Adresse de livraison',
    'payment': 'Paiement',
    'productAmount': 'Montant des produits',
    'discount': 'Remise',
    'shipping': 'Frais de port',
    'totalAmount': 'Montant total',
    'trackThisPackage': 'SUIVRE CE COLIS',
    'noOrderFound': 'Aucune commande trouvée. Veuillez vérifier votre email et numéro de commande.',
    'errorOccurred': 'Une erreur est survenue. Veuillez réessayer plus tard.',
    'enterTrackingNumber': 'Veuillez entrer votre numéro de suivi.',
    'loadingTracking': 'Chargement des informations de suivi...',
    'searchingOrder': 'Recherche de votre commande...',
    'enterBothFields': 'Veuillez saisir l\'email et le numéro de commande.'
  },
  // 德语
  'de': {
    'trackYourOrder': 'Verfolgen Sie Ihre Bestellung',
    'orderNumber': 'Bestellnummer',
    'trackingNumber': 'Tracking-Nummer',
    'email': 'E-Mail',
    'findOrder': 'BESTELLUNG FINDEN',
    'track': 'VERFOLGEN',
    'orderDetails': 'Bestelldetails',
    'product': 'Produkt',
    'quantity': 'Menge',
    'total': 'Summe',
    'status': 'Status',
    'size': 'Größe',
    'packaging': 'Verpackung: Kartonverpackung',
    'sku': 'Artikelnummer',
    'shipped': 'Versendet',
    'processing': 'In Bearbeitung',
    'deliveryAddress': 'Lieferadresse',
    'payment': 'Zahlung',
    'productAmount': 'Produktbetrag',
    'discount': 'Rabatt',
    'shipping': 'Versand',
    'totalAmount': 'Gesamtbetrag',
    'trackThisPackage': 'DIESES PAKET VERFOLGEN',
    'noOrderFound': 'Keine Bestellung gefunden. Bitte überprüfen Sie Ihre E-Mail und Bestellnummer.',
    'errorOccurred': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
    'enterTrackingNumber': 'Bitte geben Sie Ihre Tracking-Nummer ein.',
    'loadingTracking': 'Tracking-Informationen werden geladen...',
    'searchingOrder': 'Suche nach Ihrer Bestellung...',
    'enterBothFields': 'Bitte geben Sie E-Mail und Bestellnummer ein.'
  },
  // 西班牙语
  'es': {
    'trackYourOrder': 'Seguimiento de su Pedido',
    'orderNumber': 'Número de Pedido',
    'trackingNumber': 'Número de Seguimiento',
    'email': 'Correo electrónico',
    'findOrder': 'BUSCAR PEDIDO',
    'track': 'SEGUIR',
    'orderDetails': 'Detalles del Pedido',
    'product': 'Producto',
    'quantity': 'Cantidad',
    'total': 'Total',
    'status': 'Estado',
    'size': 'Tamaño',
    'packaging': 'Embalaje: Paquete de cartón',
    'sku': 'SKU',
    'shipped': 'Enviado',
    'processing': 'En Proceso',
    'deliveryAddress': 'Dirección de entrega',
    'payment': 'Pago',
    'productAmount': 'Importe del producto',
    'discount': 'Descuento',
    'shipping': 'Envío',
    'totalAmount': 'Importe total',
    'trackThisPackage': 'SEGUIR ESTE PAQUETE',
    'noOrderFound': 'No se encontró ningún pedido. Compruebe su correo electrónico y número de pedido.',
    'errorOccurred': 'Se ha producido un error. Por favor, inténtelo de nuevo más tarde.',
    'enterTrackingNumber': 'Por favor, introduzca su número de seguimiento.',
    'loadingTracking': 'Cargando información de seguimiento...',
    'searchingOrder': 'Buscando su pedido...',
    'enterBothFields': 'Por favor introduzca correo electrónico y número de pedido.'
  }
};

// 获取翻译函数
function detectLanguage() {
  // 0. 检查HTML或父元素的lang属性
  const htmlLang = document.documentElement.lang || document.body.getAttribute('lang');
  if (htmlLang && translations[htmlLang]) {
    console.log(`从HTML lang属性检测到语言: ${htmlLang}`);
    return htmlLang;
  }
  
  // 1. 尝试从URL参数获取
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam && translations[langParam]) {
    return langParam;
  }
  
  // 2. 尝试从浏览器语言获取
  const browserLang = navigator.language || navigator.userLanguage;
  const shortLang = browserLang.split('-')[0]; // 例如 'en-US' -> 'en'
  
  if (translations[shortLang]) {
    return shortLang;
  }
  
  // 3. 如果都不匹配，返回默认语言（英语）
  return 'en';
}

// 当前语言
let currentLang = detectLanguage();

// 翻译函数
function t(key) {
  return translations[currentLang][key] || translations['en'][key] || key;
}

// 更新UI语言
function updateUILanguage() {
  // 更新静态UI元素
  const trackTitle = document.querySelector('.track-title');
  if (trackTitle) trackTitle.textContent = t('trackYourOrder');
  
  const orderTab = document.getElementById('order-tab');
  if (orderTab) orderTab.textContent = t('orderNumber');
  
  const trackingTab = document.getElementById('tracking-tab');
  if (trackingTab) trackingTab.textContent = t('trackingNumber');
  
  const emailInput = document.getElementById('email');
  if (emailInput) emailInput.placeholder = t('email');
  
  const orderNameInput = document.getElementById('orderName');
  if (orderNameInput) orderNameInput.placeholder = t('orderNumber');
  
  const findOrderButton = document.getElementById('findOrderButton');
  if (findOrderButton) findOrderButton.textContent = t('findOrder');
  
  const yqNumInput = document.getElementById('YQNum');
  if (yqNumInput) yqNumInput.placeholder = t('trackingNumber');
  
  const trackButton = document.getElementById('trackButton');
  if (trackButton) trackButton.textContent = t('track');
}

// 语言切换函数
function changeLanguage(lang) {
  if (translations[lang]) {
    currentLang = lang;
    
    // 标记用户已手动选择语言
    sessionStorage.setItem('manualLanguageSelection', 'true');
    // 保存用户选择的语言
    sessionStorage.setItem('selectedLanguage', lang);
    console.log(`用户手动设置语言为: ${lang}`);
    
    // 更新语言选择器
    const langSelect = document.getElementById('language-select');
    if (langSelect) {
      langSelect.value = lang;
    }
    
    updateUILanguage();
    
    // 如果已经有结果显示，尝试重新渲染结果
    const resultDiv = document.getElementById('result');
    if (resultDiv && resultDiv.innerHTML.includes('order-info-card')) {
      // 检查findOrder函数是否存在，避免直接调用可能未定义的函数
      if (typeof findOrder === 'function') {
        findOrder();
      } else {
        console.log('警告: 尝试重新查询订单，但findOrder函数未定义');
        // 可以考虑添加一个回调队列或使用自定义事件来处理这种情况
        window.addEventListener('orderTrackingLoaded', function() {
          if (typeof findOrder === 'function') findOrder();
        }, { once: true });
      }
    }
  }
} 